import React from "react";
import { NavLink } from "react-router-dom";
import { theme } from "../../../theme";
import Header from "./header";
import { data } from "../data";
import { Badge } from "@mui/material";

const FullSidebar = ({ ftmCount, jobCount, isFullSidebar, setIsFullSidebar, sidebarRef }) => { 
    return (
        <aside
            ref={sidebarRef}
            className="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3 bg-gradient-dark"
            id="sidenav-main"
            style={{ overflowX: 'hidden', zIndex: 1 }}
        >
            <Header />
            <hr className="horizontal light mt-0 mb-2" />

            <div className="collapse navbar-collapse  w-auto" id="sidenav-collapse-main" style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                <ul className="navbar-nav">
                    {data.map((item, data_index) => (
                        <React.Fragment key={data_index}>
                            {item.heder !== "" ? (
                                <li className="nav-item mt-3">
                                    <h6 className="ps-4 ms-2 text-uppercase text-xs text-white font-weight-bolder opacity-8">{item.heder}</h6>
                                </li>
                            ) : null}

                            {item.list.map((list_item, index) => (
                                <li className="nav-item" key={index}>
                                    <NavLink
                                        className={({ isActive }) => (isActive ? `nav-link text-white active bg-gradient-${theme.main}` : 'nav-link text-white')}
                                        to={list_item.to}
                                        style={{ backgroundColor: list_item.to ? 'none' : 'transparent' }}
                                    >
                                        {list_item.name === "Applications" || list_item.name === "Cancelled Jobs" ? (
                                            <Badge
                                                badgeContent={list_item.name === "Applications" ? ftmCount : jobCount}
                                                color={theme.sidebar_notification_count_color}
                                            >
                                                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                                    <i className="material-icons opacity-10">{list_item.icon}</i>
                                                </div>
                                                <span className="nav-link-text ms-1">{list_item.name}</span>
                                            </Badge>
                                        ) : (
                                            <>
                                                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                                    <i className="material-icons opacity-10">{list_item.icon}</i>
                                                </div>
                                                <span className="nav-link-text ms-1">{list_item.name}</span>
                                            </>
                                        )}
                                    </NavLink>
                                </li>
                            ))}
                        </React.Fragment>
                    ))}
                </ul>
            </div>

            {/* <FooterBtn
                isFullSidebar={isFullSidebar}
                setIsFullSidebar={setIsFullSidebar}
            /> */}

        </aside>
    );
}

export default FullSidebar;